import { Box, Typography } from '@mui/material';
import StaticPage from '../../components/StaticPage';

const sections = [
    {
        h: '1. Acceptance of terms',
        body: 'By creating an account or using The Creator Match, you agree to these terms. If you do not agree, please do not use the platform.',
    },
    {
        h: '2. Accounts',
        body: 'You are responsible for the accuracy of the information on your brand or creator profile, and for keeping your login credentials secure. You must be old enough to enter a binding agreement in your jurisdiction to create an account.',
    },
    {
        h: '3. Use of the platform',
        body: 'The Creator Match is a discovery and matching tool. We surface creators to brands (and vice versa) and provide search, AI matching and live data tools. We are not a party to any collaboration, contract or payment agreed between a brand and a creator.',
    },
    {
        h: '4. Creator listings and pricing',
        body: 'Creators are responsible for the accuracy of the platforms, content categories and rates listed on their profile. Rates shown are set by the creator and may change without notice.',
    },
    {
        h: '5. Acceptable use',
        body: 'You agree not to misuse the platform: no scraping beyond normal use, no impersonating another person or brand, and no using contact information obtained through The Creator Match for unrelated spam.',
    },
    {
        h: '6. Third-party platforms',
        body: 'The Creator Match displays data sourced from third-party platforms (Instagram, TikTok, YouTube and others). We do not control and are not responsible for the accuracy of that data.',
    },
    {
        h: '7. Limitation of liability',
        body: 'The Creator Match is provided "as is" without warranties of any kind. We are not liable for any dispute, loss or damage arising from a collaboration between a brand and a creator.',
    },
    {
        h: '8. Changes to these terms',
        body: 'We may update these terms as the platform evolves. Continued use after a change means you accept the updated terms.',
    },
];

export default function TermsPage() {
    return (
        <StaticPage title="Terms of Service" subtitle="Last updated 2026.">
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                {sections.map((s) => (
                    <Box key={s.h}>
                        <Typography variant="h6" fontWeight={700} sx={{ mb: 0.5 }}>{s.h}</Typography>
                        <Typography color="text.secondary" sx={{ lineHeight: 1.7 }}>{s.body}</Typography>
                    </Box>
                ))}
            </Box>
        </StaticPage>
    );
}
